export interface ExportAttachmentsHandler {
  submit: () => Promise<void>;
}

export interface ExportAttachmentProps {
  reload?: () => void;
}

export interface ExportAttachmentViewProps {
  exportItemTypes: ExportItemTypeProps[];
}

export interface ExportItemTypeProps {
  title: string;
  isDownloadAvailable: boolean;
  statusLabelText: string;
  exportItems: ExportItemProps[];
  displayLoading?: boolean;
  emptyListPlaceholder?: React.ReactNode;
}

export interface ExportItemProps {
  isDownloadAvailable: boolean;
  itemText: string;
  itemSubtext?: string;
}

export class ExportAttachmentStatus {
  success: boolean;
  typeText: string;
  reason?: string;
  typeKey?: string;

  constructor(success: boolean, typeText: string, reason?: string, typeKey?: string) {
    this.success = success;
    this.typeText = typeText;
    this.reason = reason;
    this.typeKey = typeKey;
  }

  static createSuccess(typeText: string): ExportAttachmentStatus {
    return new ExportAttachmentStatus(true, typeText);
  }

  static createError(typeText: string, reason?: string, typeKey?: string): ExportAttachmentStatus {
    return new ExportAttachmentStatus(false, typeText, reason, typeKey);
  }
}
